export const Review = {
  bindings: {
    review: '<',
    replies: '<',
    memberId: '<',
    onLike: '&',
    onSubmit: '&',
    onShowReplies: '&',
  },

  template: `
    <div class="review d-block">
      <review-reply
        data="$ctrl.review"
        is-user="$ctrl.memberId === $ctrl.review.member.id"
        on-like="$ctrl.onLike({ reviewId: reviewId })"
        on-reply="$ctrl.onReply($ctrl.review.id)"
        on-show-replies="$ctrl.onShowReplies({ parentId: reviewId })">
      </review-reply>
      <div class="review-replies ml-5">
        <review-reply
          data="$ctrl.replies[replyId]"
          is-user="$ctrl.memberId === $ctrl.replies[replyId].member.id"
          on-like="$ctrl.onLike({ reviewId: reviewId })"
          on-reply="$ctrl.onReply($ctrl.review.id)"
          ng-repeat="replyId in $ctrl.review.replies track by $index">
        </review-reply>
        <form-review
          data-form-id="{{ $ctrl.review.id }}"
          wording-singular="Reply"
          on-submit="$ctrl.onSubmit({ parentId: $ctrl.review.id, data: data })"
          on-cancel="$ctrl.showForm = false"
          ng-show="$ctrl.showForm">
        </form-review>
      </div>
    </div>`,

  controller($timeout) {
    'ngInject';

    return {
      $onInit() {
        this.showForm = false;
      },

      onReply(id) {
        this.showForm = true;

        $timeout(() => {
          $('html, body').animate({
            scrollTop: $(`[data-form-id="${id}"]`).offset().top,
          });
        });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Review/Review.js